import { Pipe } from '@angular/core';
import { LabelOrAlternativePipe } from './label-or-alternative.pipe';
import { IPBoardPlacementTypeChoices } from 'src/app/model/product/ip-board/ip-board-placement-type';

@Pipe({
  name: 'ipBoardPlacementTypeOrAlternative'
})
export class IPBoardPlacementTypeOrAlternativePipe extends LabelOrAlternativePipe {
  constructor() {
    super(IPBoardPlacementTypeChoices.OTHER.ordinal);
  }
}
